import { connect } from 'react-redux';
import { getDynamicFormInfos, getFormProductType, getStaticFormInfos } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { WorkspaceType } from 'state/workspaces/model';

interface OwnProps {
  className?: string;
  tabId: string;
  workspaceType: WorkspaceType;
}

interface StateProps {
  productType?: string;
  productSubType?: string;
}
export type TutorialProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const productType = getFormProductType(state, tabId);
  if (workspaceType === 'static') {
    const infos = getStaticFormInfos(state, tabId);
    return {
      productType,
      productSubType: infos?.productDescription,
    };
  } else {
    const infos = getDynamicFormInfos(state, tabId)!;
    return {
      productType,
      productSubType: infos?.instrumentContractName,
    };
  }
};

export const connectTutorial = connect(mapStateToProps);
